import { render, staticRenderFns } from "./SaveDataViewModal.vue?vue&type=template&id=5d63ab3d"
import script from "./SaveDataViewModal.vue?vue&type=script&lang=js"
export * from "./SaveDataViewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports